import React from 'react';

// Styles
import { Container } from './styles';

// Interface
interface Props {
  children: React.ReactNode;
  type: 'old' | 'current' | 'instalments';
}

export function Price({ children, type }: Props) {
  return <Container type={type}>{children}</Container>;
}
